import instance from './base';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getContentList = (pageNumber: number, pageType: string): Promise<any> => {
  return instance.post('/rest/pc-direct/hapame/feed', { pageNumber, pageType });
};
export { getContentList };
